const { BigXCloseBtn } = require("components/Icons")


const BankAddesSuccesfully = ({showPupup,text, closePopup, error}) => {

 return (
     showPupup &&
        <div className='layout-popup'>
        <div className='main-popup-cont'>
        <div className={`popup-contain ${error && 'bg-danger'}`}>

           <p>{text}</p>
            <BigXCloseBtn onClick={closePopup}/>
        </div>
        </div>
        </div>
    )
}

export default BankAddesSuccesfully
